import React from "react";
import { Link } from "react-router-dom";
import "./Contact.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ContactForm from "./ContactForm";

// Reusable Contact section.
// When isStandalone=true, render breadcrumbs + page-title variant.
const Contact = ({ isStandalone = false }) => (
    <section id="contact" className={`section-wrapper${isStandalone ? ' page' : ''}`}>
        <div className="section-inner">
            {isStandalone && (
                <nav aria-label="Breadcrumb" className="breadcrumbs">
                    <ol>
                        <li><Link to="/">Home</Link></li>
                        <li aria-current="page">Contact</li>
                    </ol>
                </nav>
            )}
            <h1 className={isStandalone ? "page-title" : "section-title"}>Contact</h1>
            <div className="contact-content">
                <p>Got a project? Let's talk! Find me on my dev channels or drop a note below.</p>
                <div className="contact-actions" role="region" aria-label="Social media links">
                    <a
                        href="https://www.linkedin.com/in/kayleighschlupp/"
                        className="btn btn-icon"
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="Open LinkedIn (opens in a new tab)"
                    >
                        <FontAwesomeIcon icon={['fab', 'linkedin-in']} />
                    </a>

                    <a
                        href="https://github.com/kkowatsch"
                        className="btn btn-icon"
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="Open GitHub (opens in a new tab)"
                    >
                        <FontAwesomeIcon icon={['fab', 'github']} />
                    </a>
                </div>
            </div>

            <ContactForm />
        </div>
    </section>
);

export default Contact;